import { useQuery } from '@tanstack/react-query';
import { SystemSettingQueryResponse } from '../../globalModels/common/SystemSettingQueryResponse';
import { getAxios } from '../../lib/axios';
import { ApiEndpoints } from '../../constants/endpoints/apiEndpoints.ts';

const getSystemSetting = async (request: string): Promise<SystemSettingQueryResponse> => {
  return (await getAxios().get(ApiEndpoints.systemSettings.getByKey(request))).data;
};

export const useSystemSettingByKeyQuery = (request: string) => {
  return useQuery({
    queryKey: ['system-setting', request],
    queryFn: () => getSystemSetting(request)
  });
};
